/// <amd-module name="Feed/Common/Utils/Validator" />
import * as Url from "VSS/Platform/Util/Url";

const CoreInvalidCharacters = [
    "~",
    ";",
    "{",
    "}",
    "'",
    "+",
    "=",
    ",",
    "<",
    ">",
    "|",
    "/",
    "\\",
    "?",
    ":",
    "&",
    "$",
    "*",
    '"',
    "#",
    "[",
    "]",
    "%"
];

const FeedNameInvalidChars = CoreInvalidCharacters.concat(" ", "@");
const UpstreamInvalidChars = CoreInvalidCharacters;

function ValidateName(name: string, maxLength: number, invalidChars: string[]): boolean {
    if (name == null || name.length === 0 || name.length > maxLength) {
        return false;
    }

    for (const invalidCharacter of invalidChars) {
        if (name.indexOf(invalidCharacter) !== -1) {
            return false;
        }
    }

    return true;
}

/**
 * Validates feed names
 * Name should not start with _ or . and end with .
 * Max length is 64
 * Should not contain special charaters
 */
export function ValidateFeedName(name: string): boolean {
    return (
        ValidateName(name, 64, FeedNameInvalidChars) &&
        name.charAt(0) !== "_" &&
        name.charAt(0) !== "." &&
        name.charAt(name.length - 1) !== "."
    );
}

/**
 * Validates release-view names
 * Name should not start with _ or . and end with .
 * Max length is 64
 * Should not contain special charaters
 */
export function ValidateViewName(name: string): boolean {
    // currently the same as feed name validation
    return ValidateFeedName(name);
}

/**
 * Validates upstream source names
 * Name should not start with _ or . and end with .
 * Max length is 30
 * Should not contain special charaters (but allows ' ' and '@')
 */
export function ValidateUpstreamSourceName(name: string): boolean {
    return ValidateName(name, 30, UpstreamInvalidChars);
}

/**
 * Validates upstream source location
 * Should be a valid url using the http or https protocol
 */
export function IsUrlValid(location: string): boolean {
    const uri = new Url.Uri(location);
    if ((uri.scheme !== "https" && uri.scheme !== "http") || !isUrlWithinConstraints(location) || uri.host === "") {
        return false;
    }
    return true;
}

/**
 * Verifies that the given url is within the constraints of 2000 characters.
 *
 * @param url The url to verify.
 * @returns {boolean}
 */
function isUrlWithinConstraints(url: string): boolean {
    return url ? url.length <= 2000 : false;
}
